import React, { useEffect, useState } from "react";
import { connect } from 'react-redux';
import ProjectForm from "./ProjectForm";
import { CircularProgress } from "@material-ui/core";
import * as Yup from "yup";
import { parseURL } from "../../../sc-utilities";
import * as actions from './store/projectActions';
import History from "../../../../History";
import { hasPermission } from "../../../sc-utilities";
import { CancelToken } from 'axios';
import * as groupActions from "../../../sc-group/Group/store/groupActions";

const ProjectEdit = props => {
    const { activeCustomerID, loadProject, translations, project, loadProjectInit, updateProject, permissions, fetchGroups } = props;
    const [editData, setEditData] = useState({ loadingData: true });
    const [groups, setGroups] = useState(null);

    useEffect(() => {
        const requestToken = CancelToken.source();
        const fetchData = async () => {
            await loadProject({ ActiveCustomerID: activeCustomerID, ProjectID: parseURL(window.location.href).projectID }, { cancelToken: requestToken.token })
            setEditData({ loadingData: false })
        }
        fetchData();
        return () => {
            requestToken.cancel('Operation canceled by the user.');
            loadProjectInit();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        const getGroups = async () => {
            const resultGroups = await fetchGroups({ ActiveCustomerID: activeCustomerID });
            if (resultGroups) {
                let groupsToSet = resultGroups.data.map(group => ({ value: group.GroupID, displayValue: group.Name }));
                if (hasPermission(permissions, 'access_all_projects_on_customer')) {
                    groupsToSet = [...groupsToSet, { value: 'n/a', displayValue: 'n/a' }];
                }
                setGroups(groupsToSet);
            }
        }

        if (hasPermission(permissions, 'group_list')) {
            getGroups();
        }
    }, [fetchGroups, activeCustomerID, permissions]);

    const handleSubmit = async data => {
        if (data.GroupID === 'n/a') {
            data.GroupID = null;
        }
        let result = await updateProject({ ...data, ActiveCustomerID: activeCustomerID, ProjectID: parseURL(window.location.href).projectID });
        if (result) {
            setEditData({ loadingData: true });
            History.goBack()
        }
    };

    let initialValues = {
        Name: project && project.Name ? project.Name : '',
        FancyName: project && project.FancyName ? project.FancyName : '',
        GroupID: project?.GroupID ?? 'n/a'
    }

    let formSettings = {
        Validation: {
            Name: Yup.string().required("Required"),
            FancyName: Yup.string().required("Required")
        },
        FormTitle: translations["edit_project"] || "Edit project",
        ButtonSubmit: hasPermission(permissions, 'project_save') ? {
            Title: translations["save"] || "SAVE"
        } : null
    };

    return (
        !editData.loadingData ?
            <ProjectForm
                formSettings={formSettings}
                initialValues={initialValues}
                handleSubmit={handleSubmit}
                translations={translations}
                edit={true}
                permissions={editData.permissions}
                groups={groups}
            /> :
            <CircularProgress />
    );
};

const mapStateToProps = state => {
    return {
        activeCustomerID: state.core.login.activeCustomer.CustomerID,
        project: state.client.projects.loaded,
        translations: state.translate && state.translate.translations ? state.translate.translations.activeTranslations || {} : {},
        permissions: state?.core?.login?.permissions || []
    };
};

const mapDispatchToProps = dispatch => {
    return {
        updateProject: data => dispatch(actions.editProject(data)),
        loadProject: (data, options) => dispatch(actions.loadProject(data, options)),
        loadProjectInit: () => dispatch(actions.loadProjectInit()),
        fetchGroups: params => dispatch(groupActions.fetchGroups(params))
    };
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(ProjectEdit);
